module.exports = __webpack_public_path__ + "assets/img/advantage1.3238310d.png";